<template>
    <div class="lp-create">
        <div class="lp-create__header">
            <div class="lp-create__header__inner">
                <div class="header__text">
                    <h2><span class="header__text__main--small">フォームに入力して書類がすぐできる</span><span
                        class="header__text__main--big">複雑で面倒な書類を<br>かんたん・スムーズに作成</span></h2>
                    <p class="description">許認可から補助金申請、契約書の作成まで<br>高品質かつ迅速な書類準備でビジネスを効率化</p>
                    <div class="header__btns">
                        <div>
                        <nuxt-link to="#applications" class="button button--create"><span class="big">対応書類を見る</span><span
                            class="small">{{ applications.length }}種類の書類に対応</span></nuxt-link>
                        </div>
                    </div>
                </div>

                <div class="lp-create__header__image">
                    <img src="/img/lp-create/hero-image.png" srcset="/img/lp-create/hero-image.png 1x, /img/lp-create/hero-image@2x.png 2x" alt="LegalScript書類作成" loading="lazy">
                </div>
            </div>
        </div>
        <div class="lp-create__point">
            <div class="lp-create__point__inner">
                <div class="lp-create__copy mb56">
                    <h2 class="lp-create__copy__title">専門知識がなくても、すぐに必要書類が作成できます</h2>
                    <p class="lp-create__copy__description">書類作成のコストの削減・担当者の事務負担軽減にピッタリ</p>
                </div>
                <div class="lp-create__point__contents">
                    <ul class="lp-create__point__list mb56">
                        <li class="lp-create__point__item">
                            <div class="lp-create__point__box">
                                <p class="lp-create__point__copy">複雑な書類の作成を<br>一人でやるのは不安…</p>
                            </div>
                            <div class="lp-create__point__image">
                                <img src="/img/lp-create/point1.png" srcset="/img/lp-create/point1.png 1x, /img/lp-create/point1@2x.png 2x" alt="書類がすぐできる" loading="lazy">
                            </div>
                            <p class="lp-create__point__title">ステップに従って入力すると<br><span class="point">書類が自動で作成</span>される</p>
                            <p class="lp-create__point__description">ステップは専門家が監修。<br>難しい用語も説明つきで、詳しい知識がなくても安心して書類を作成できます。</p>
                        </li>
                        <li class="lp-create__point__item">
                            <div class="lp-create__point__box">
                                <p class="lp-create__point__copy">作成した書類の<br>入力間違いやミスが心配…</p>
                            </div>
                            <div class="lp-create__point__image">
                                <img src="/img/lp-create/point2.png" srcset="/img/lp-create/point2.png 1x, /img/lp-create/point2@2x.png 2x" alt="修正もカンタン" loading="lazy">
                            </div>
                            <p class="lp-create__point__title">作成後の<span class="point">書類の修正もカンタン</span><br>申請のガイド付きの書類も</p>
                            <p class="lp-create__point__description">書類は一定期間、編集可能なため安心。<br>さらに申請書類などは、専門家監修の申請ガイドがダウンロードできます。</p>
                        </li>
                        <li class="lp-create__point__item">
                            <div class="lp-create__point__box">
                                <p class="lp-create__point__copy">そもそも作成のための<br>まとまった時間が取れない…</p>
                            </div>
                            <div class="lp-create__point__image">
                                <img src="/img/lp-create/point3.png" srcset="/img/lp-create/point3.png 1x, /img/lp-create/point3@2x.png 2x" alt="途中保存もできる" loading="lazy">
                            </div>
                            <p class="lp-create__point__title">パソコン・スマホから利用可能<br>入力は<span class="point">ステップ毎に自動保存</span></p>
                            <p class="lp-create__point__description">入力情報はステップ毎に途中保存されるので、忙しい方でもスキマ時間に書類作成を進めていくことができます。</p>
                        </li>
                    </ul>
                    <div class="lp-create__point__other mb56">
                        <div class="lp-create__point__other__main">
                            <p class="lp-create__point__other__title">100種類以上の書式のダウンロードが可能</p>
                            <p class="lp-create__point__other__description">休職届や手当の申請書など総務や労務などで取り扱う書類、事業概況書などの行政手続き書類など<br>幅広い種類の書式１００種類以上を無料で何枚でもダウンロードできます。<br>※書式ダウンロードは書類の自動作成はできません</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="lp-create__register">
                <nuxt-link class="button button--create-inner" to="/auth/register">書類を作成する</nuxt-link>
                <nuxt-link class="button button--create-innersub" to="/contact-application">お問い合わせ</nuxt-link>
            </div>
        </div>
        <div class="lp-create__document" id="applications">
            <div class="lp-create__document__inner">
                <div class="lp-create__copy">
                    <h2 class="lp-create__copy__title">対応書類</h2>
                    <p class="lp-create__copy__description">今後補助金や行政手続き、許認可の申請書類など幅広い種類の書類に順次対応予定です</p>
                </div>
                <div class="lp-create__document__content">
                    <div class="lp-create__document__section" v-for="category in categories" :key="category.id">
                        <p class="lp-create__document__category">{{ category.name }}</p>
                        <ul class="lp-create__document__list">
                            <li class="lp-create__document__item">
                                <div class="lp-create__document__item__content" v-for="(app, index) in category.applications" :key="app.id">
                                    <nuxt-link :to="app.landing ? `/landing/${app.landing[0].url}` : `/landing`" class="lp-create__document__link">
                                        {{ app.name }}
                                    </nuxt-link>
                                    <p v-if="index !== category.applications.length - 1" class="separator">/</p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="lp-create__toki">
            <div class="lp-create__toki__inner">
                <div class="lp-create__toki__texts">
                    <p class="lp-create__toki__copy mb16">株式・合同・有限会社に対応</p>
                    <h2 class="lp-create__toki__title mb32">法人の登記書類の作成なら<br>LegalScript</h2>
                    <p class="lp-create__toki__description mb32">会社設立・本店移転・役員変更<br class="pc-only" />代表取締役の住所変更・商号変更・目的変更などの書類を自動で作成</p>
                    <a href="https://legal-script.com/?rf=admin" target="_blank" class="button button--primary">詳しくはこちら</a>
                </div>
                <div class="lp-create__toki__image">
                    <img src="/img/lp-create/toki-main.png" srcset="/img/lp-create/toki-main.png 1x, /img/lp-create/toki-main@2x.png 2x" alt="①" loading="lazy">
                </div>
            </div>
        </div>
        <div class="lp-create__flow">
            <div class="lp-create__flow__inner">
                <div class="lp-create__copy mb56">
                    <h2 class="lp-create__copy__title">ご利用の流れ</h2>
                    <p class="lp-create__copy__description">作成する書類に応じて必要な情報を入力するだけで、該当の書類をダウンロードすることができます。</p>
                </div>
                <ul class="lp-create__flow__list mb56">
                    <li class="lp-create__flow__item">
                        <div class="lp-create__flow__image">
                            <img src="/img/lp-create/flow-icon1.png" srcset="/img/lp-create/flow-icon1.png 1x, /img/lp-create/flow-icon1@2x.png 2x" alt="①" loading="lazy">
                        </div>
                        <div class="lp-create__flow__text">
                            <p class="lp-create__flow__title">まずは<br>無料アカウント登録</p>
                            <p class="lp-create__flow__small">アカウント登録するだけで100種類以上の書式のダウンロードが可能です。</p>
                        </div>
                    </li>
                    <li class="lp-create__flow__item">
                        <div class="lp-create__flow__image">
                            <img src="/img/lp-create/flow-icon2.png" srcset="/img/lp-create/flow-icon2.png 1x, /img/lp-create/flow-icon2@2x.png 2x" alt="①">
                        </div>
                        <div class="lp-create__flow__text">
                            <p class="lp-create__flow__title">作成したい書類を選択して<br>ステップに沿って必要な情報を入力</p>
                            <p class="lp-create__flow__small">書類はステップごとに途中保存され、いつでも入力を再開できます。</p>
                        </div>
                    </li>
                    <li class="lp-create__flow__item">
                        <div class="lp-create__flow__image">
                            <img src="/img/lp-create/flow-icon3.png" srcset="/img/lp-create/flow-icon3.png 1x, /img/lp-create/flow-icon3@2x.png 2x" alt="①">
                        </div>
                        <div class="lp-create__flow__text">
                            <p class="lp-create__flow__title">クレジットカードでのお支払い後<br>
書類をダウンロード</p>
                            <p class="lp-create__flow__small">※クレジットカードはVISA/Master/JCB/AMEX/Dinersに対応</p>
                        </div>
                    </li>
                </ul>
                <div class="lp-create__register">
                    <nuxt-link class="button button--create-inner" to="/auth/register">書類を作成する</nuxt-link>
                    <nuxt-link class="button button--create-innersub" to="/contact-application">お問い合わせ</nuxt-link>
                </div>
            </div>
        </div>
        <div class="lp-create__faq">
            <div class="lp-create__faq__inner">
                <div class="lp-create__copy mb48">
                    <h2 class="lp-create__copy__title">よくあるご質問</h2>
                </div>
                <div class="lp-create__faq__content">
                    <ul class="lp-create__faq__list">
                        <li class="lp-create__faq__item">
                            <p class="faq-q">Q.サービス利用にかかる料金はいくらですか？</p>
                            <p class="faq-a">A. 書類によって異なります。※書式テンプレートは全て無料です</p>
                        </li>
                        <li class="lp-create__faq__item">
                            <p class="faq-q">Q.書類作成の知識がなくても大丈夫ですか？</p>
                            <p class="faq-a">A. 申請や書類作成の詳しい知識がなくてもご利用いただけます。専門家が監修したステップに従って入力いただくと書類が自動で作成されます。</p>
                        </li>
                        <li class="lp-create__faq__item">
                            <p class="faq-q">Q.領収書は発行できますか？</p>
                            <p class="faq-a">A. 書類のダウンロードページ・領収書の発行ページにて発行できます。</p>
                        </li>
                        <li class="lp-create__faq__item">
                            <p class="faq-q">Q.どんな書類が出力されますか？</p>
                            <p class="faq-a">A. 書類によって異なりますが、各書類・申請に必要な書類一式を出力します。</p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import heatMapToolMixin from '~/mixins/heatMapToolMixin';
    import { clearRegisterLandingUrl } from '@/helpers/registerLanding';

    export default {
        name: 'lp-create',
        layout: 'frontend/lp-create',
        mixins: [heatMapToolMixin],
        async asyncData({app, $frontendRepositories}) {
            clearRegisterLandingUrl(app.$cookies);
            const {errResponse, data: responseData} = await $frontendRepositories.landing.getPublicApplication();
            const applications = errResponse ? [] : responseData.data;

            const {errorResponseCategory, data: responseDataCategory} = await $frontendRepositories.landing.getCategoryWithPublicApplication();
            const categories = errorResponseCategory ? [] : responseDataCategory.data;

            return {
                applications: applications,
                categories: categories,
            }
        },
        mounted() {
            clearRegisterLandingUrl(this.$cookies);
        },
        data() {
            return {
                title: 'LegalScript書類作成',
                metaHeader: [
                    {charset: 'utf-8'},
                    { hid: 'og:site_name', property: 'og:site_name', content: 'LegalScript書類作成' },
                    { hid: 'og:url', property: 'og:url', content: 'https://admin.legal-script.com/lp/create' },
                    { hid: 'og:title', property: 'og:title', content: 'LegalScript書類作成' },
                    { hid: 'og:image', property: 'og:image', content: 'https://admin.legal-script.com/frontend/img/legal-script-application.png' },
                    { hid: 'og:description', property: 'og:description', content: '簡単入力で高品質な書類作成を実現。許認可・補助金など幅広く対応し、コスト削減と事務負担を軽減。100以上の無料テンプレート利用可能、途中保存と専門家監修のガイド付きで安心。' },
                ],
            };
        },
    }
</script>

<style scoped>
.lp-create__document__item__content {
  display: inline;
}

.lp-create__document__link {
  text-decoration: none;
  font-size: 1.6rem;
  line-height: 2;
}

.lp-create__document__link:hover {
  text-decoration: underline;
}

.separator {
  margin: 0 24px;
}
</style>
